import React from 'react';

// Tailwind conversion of the old CatalogStyled block. Children (.catalog-tools,
// .search, .custom-tools, .filters, .table, ...) are rendered by callers, so
// their rules are reached via [&_.x]: arbitrary descendant variants. mobile:
// == css.mobileMedia (max-width 1000px); flexVerticalCenter == flex flex-col
// justify-around.
//
// `flex-1 min-h-0` (was the original `height: 100%`): the catalog is always a
// flex-column child of PageBody, so flex-grow bounds it robustly without relying
// on percentage-height resolving through the page-body chain. This is what makes
// the inner .table (overflow-auto → flexbox auto min-height 0) the scroll
// container while .catalog-tools stays fixed — independent of page header height.
const catalogClassName = [
  'catalog relative box-border flex min-h-0 flex-1 flex-col',
  // .catalog-tools
  '[&_.catalog-tools]:mb-3 [&_.catalog-tools]:flex [&_.catalog-tools]:items-center [&_.catalog-tools]:gap-2',
  '[&_.catalog-tools_.search]:mt-[1px]',
  '[&_.catalog-tools_.custom-tools]:ml-auto',
  '[&_.catalog-tools_.custom-tools-mobile-opener]:hidden',
  '[&_.catalog-tools_.filters]:ml-auto [&_.catalog-tools_.filters]:flex [&_.catalog-tools_.filters]:gap-2',
  '[&_.catalog-tools_.filters_.filters-label]:flex [&_.catalog-tools_.filters_.filters-label]:flex-col [&_.catalog-tools_.filters_.filters-label]:justify-around',
  '[&_.catalog-tools_.filter]:w-auto',
  // .catalog-tools mobile overrides
  'mobile:[&_.catalog-tools]:w-full',
  'mobile:[&_.catalog-tools_.search_input]:max-w-60',
  'mobile:[&_.catalog-tools_.custom-tools]:absolute mobile:[&_.catalog-tools_.custom-tools]:top-0 mobile:[&_.catalog-tools_.custom-tools]:left-0 mobile:[&_.catalog-tools_.custom-tools]:m-auto mobile:[&_.catalog-tools_.custom-tools]:mr-auto mobile:[&_.catalog-tools_.custom-tools]:hidden mobile:[&_.catalog-tools_.custom-tools]:w-[calc(100%-4rem)] mobile:[&_.catalog-tools_.custom-tools]:rounded-input mobile:[&_.catalog-tools_.custom-tools]:border mobile:[&_.catalog-tools_.custom-tools]:border-soft mobile:[&_.catalog-tools_.custom-tools]:bg-panel mobile:[&_.catalog-tools_.custom-tools]:p-4 mobile:[&_.catalog-tools_.custom-tools]:shadow-chunky',
  'mobile:[&_.catalog-tools_.custom-tools_.filters]:gap-2',
  'mobile:[&_.catalog-tools_.custom-tools.open]:z-3 mobile:[&_.catalog-tools_.custom-tools.open]:block',
  'mobile:[&_.catalog-tools_.custom-tools-mobile-opener]:ml-auto mobile:[&_.catalog-tools_.custom-tools-mobile-opener]:flex mobile:[&_.catalog-tools_.custom-tools-mobile-opener]:flex-col mobile:[&_.catalog-tools_.custom-tools-mobile-opener]:justify-around',
  'mobile:[&_.catalog-tools_.custom-tools-mobile-opener_.icon]:flex mobile:[&_.catalog-tools_.custom-tools-mobile-opener_.icon]:flex-col mobile:[&_.catalog-tools_.custom-tools-mobile-opener_.icon]:justify-around',
  'mobile:[&_.catalog-tools_.custom-tools-mobile-opener_.icon_svg]:w-8',
  'mobile:[&_.catalog-tools_.custom-tools-mobile-opener]:text-fg-3 mobile:[&_.catalog-tools_.custom-tools-mobile-opener_.icon_svg_*]:[stroke-width:1]',
  'mobile:[&_.catalog-tools_.custom-tools-mobile-opener.open]:text-primary mobile:[&_.catalog-tools_.custom-tools-mobile-opener.open_svg_*]:[stroke-width:2]',
  // .catalog-stats
  '[&_.catalog-stats]:border-t [&_.catalog-stats]:border-soft [&_.catalog-stats]:px-3 [&_.catalog-stats]:py-2 [&_.catalog-stats]:font-mono [&_.catalog-stats]:text-[11px] [&_.catalog-stats]:tabular-nums [&_.catalog-stats]:text-fg-3',
  // .catalog-table .row-select .icon.checkmark (Table's wrapper hook is
  // `catalog-table`, not `table`, to avoid Tailwind's display:table utility).
  '[&_.catalog-table_.row-select_.icon.checkmark]:top-0',
].join(' ');

interface CatalogProps {
  children: React.ReactNode;
  className?: string;
}

export const Catalog = (props: CatalogProps) => {
  return (
    <div className={`${catalogClassName} ${props.className || ''}`}>
      {props.children}
    </div>
  );
};
